<template>
  <div :class="customClass">
    <tooltip-hover
      class="tw-w-full"
      position="top left"
      :text="
        simpleMode
          ? `${isFollowing ? $t('unfollow') : $t('follow')} ${collection.name}`
          : ''
      "
    >
      <base-button
        :class="[
          isBrowse ? 'xs:tw-text-h6 ' : 'xs:tw-text-lg',
          { 'tw-w-8': simpleMode },
        ]"
        :small="simpleMode"
        :x-large="!isBrowse && !simpleMode"
        :auto-width="simpleMode"
        :test-id="`collection-follow-${collection.id}`"
        :primary="!isBrowse"
        :secondary="isBrowse"
        :active="isFollowing"
        :full-width="!simpleMode"
        :icon="simpleMode ? (isFollowing ? 'times' : 'plus') : ''"
        :disabled="disabled"
        :status="status"
        @click="handleClick()"
      >
        <template v-if="!simpleMode" #default>
          <span class="tw-uppercase">{{
            isFollowing ? $t('following') : $t('follow')
          }}</span>
          <div
            v-if="!isBrowse"
            class="tw-flex tw-text-xs tw-font-medium tw-opacity-70 tw-space-x-2 tw-w-full tw-justify-center tw-leading-none"
          >
            <span>
              {{
                `${collection.stats?.mods_total || 0} ${ugcName(null, collection.stats?.mods_total === 1, true).value}`
              }}
            </span>
            <span>•</span>
            <span>{{ humanFilesize(collection.filesize) }}</span>
          </div>
        </template>
      </base-button>
    </tooltip-hover>

    <teleport to="body">
      <collection-subscribe-modal
        :show="isCollectionModalOpen"
        :collection="collection"
        :is-subscribed="isFollowing"
        @close:modal="hideCollectionModal"
      />
    </teleport>
  </div>
</template>

<script>
import CollectionSubscribeModal from '@components/Modals/CollectionSubscribeModal.vue'
import { useResourceValue, useStatus, useModal, useSSO } from '@composables'
import { humanNumberFormat, humanFilesize } from '@helpers/utils.js'
import TooltipHover from '@components/Message/TooltipHover.vue'
import { collectionFollowingStore, authStore } from '@stores'
import { setGlobalModal } from '@composables/useModal.js'
import { MODAL_LOGIN } from '@config/globalModals.js'
import { computed, toRefs } from 'vue'

export default {
  components: {
    CollectionSubscribeModal,
    TooltipHover,
  },
  props: {
    game: {
      type: Object,
      required: true,
    },
    collection: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isBrowse: {
      type: Boolean,
      default: false,
    },
    simpleMode: {
      type: Boolean,
      default: false,
    },
    customClass: {
      type: String,
      default: '',
    },
  },
  emits: ['subscribed'],
  setup(props) {
    const { collection, game } = toRefs(props)

    const { loading: loadingSSOConfig } = useSSO()
    const { ugcName } = useResourceValue()

    const { followedCollections } = collectionFollowingStore()
    const { isLoggedIn } = authStore()

    const {
      isModalOpen: isCollectionModalOpen,
      hideModal: hideCollectionModal,
      showModal: showCollectionModal,
    } = useModal()

    const isLoading = computed(() => loadingSSOConfig.value)

    const { status } = useStatus({
      loading: isLoading,
    })

    const isFollowing = computed(() => {
      if (
        followedCollections.value?.length &&
        collection.value.id &&
        game.value?.id
      ) {
        return followedCollections.value.some(
          (subscription) => subscription?.id === parseInt(collection.value.id)
        )
      }

      return false
    })

    async function handleClick(confirm = false) {
      if (!isLoggedIn.value) {
        setGlobalModal({ modal: MODAL_LOGIN })
        return
      }

      if (confirm) hideCollectionModal()
      else showCollectionModal()
    }

    return {
      isCollectionModalOpen,
      hideCollectionModal,
      humanNumberFormat,
      humanFilesize,
      isFollowing,
      handleClick,
      ugcName,
      status,
    }
  },
}
</script>
